  /**
 * success-toast.js
 *
 * This is the clip success toast for the new clipping flow.
 */

import '../dist/templates/clipping/notice-prompt';
import '../dist/templates/clipping/success-toast';

(function(ss){
  var utils = ss.utils,
    isMobile = ss.is_mobile,
    i18n = utils.i18n(),

    SelectClipboardModal = utils.imports('SelectClipboardModal'),
    ClipboardModalShare = utils.imports('ClipboardModalShare'),
    NoticePrompt = utils.imports('NoticePrompt'),
    eventNamespace = '.successtoast',


    templates = {
      noticePrompt: utils.imports('templates.clipping.notice-prompt'),
      successToast: utils.imports('templates.clipping.success-toast')
    },

    selectors = {
      slideContainer: '.slide_container',
      slide: '.slide',
      successToastWrapper: '.success-toast-wrapper',
      content: '.content',
      changeClipboard: '.j-change-clipboard',
      shareClip: '.j-share-clip',
      selectClipboardModal: '#select-clipboard-modal',
      clipShareModal: '#clipboard-share-modal'
    },

    events = {
      clipCreated: 'clip:created',
      clipCopied: 'clip:copied',
      clipShared: 'clip:shared',
      clipMoved: 'clip:moved',
      successToastHide: 'successtoast:hide'
    },

    CLIP_SHARE_PARAM = 'clipshare';

  /**
   * Initiates a new share prompt from generic notice prompt class
   * @constructor
   */
  function SuccessToast(){
    this._init();
  }

  SuccessToast.prototype = {
    constructor: SuccessToast,

    /**
     * Initialize the toast
     * @private
     */
    _init: function(){
      this.$el = $(selectors.successToastWrapper);
      this.$noticePrompt = $(templates.noticePrompt({svg_icon_type: 'success-pebble-icon', i18n: i18n}));
      this.$el.append(this.$noticePrompt);
      this.$toastContainer = this.$noticePrompt.find(selectors.content);
      this.$slides = $(selectors.slideContainer);

      this.noticePrompt = new NoticePrompt({
        selector: selectors.successToastWrapper,
        onHide: this._onHide.bind(this)
      });

      this.clip = null;
      this.clipboard = null;
      this.hideToastTimer = null;

      this._attachEventHandlers();
    },

    /**
     * Attach various event handlers here
     * @private
     */
    _attachEventHandlers: function(){
      $(document).on(events.clipCreated, this.show.bind(this));
      $(document).on(events.clipCopied, this.show.bind(this));
      $(document).on(events.clipMoved, this.show.bind(this));

      this.$toastContainer.on('click', selectors.changeClipboard, this._onChangeClipboard.bind(this));
      this.$toastContainer.on('click', selectors.shareClip, this._onShareClip.bind(this));
    },

    /**
     * Attach events for hiding the toast
     * @private
     */
    _attachHideToastEvents: function() {
      // Hide toast if user clicks outside of it
      $(document).on('click' + eventNamespace, this.hide.bind(this));
      this.$el.on('click' + eventNamespace, function(e) {
        e.stopPropagation();
      });

      // Per WCAG 2.0, auto dismissing timed events should not be used
      // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#time-limits-required-behaviors
    },

    _onChangeClipboard: function() {
      this.selectModal = new SelectClipboardModal({
        el: selectors.selectClipboardModal,
        defaultClipboard: this.clipboard,
        actionType: 'move'
      });
      this.selectModal.open({clip: this.clip});
    },

    /**
     * Callback to open the share clip modal
     */
    _onShareClip: function() {
      var curClip = this.clip,
        position = curClip.position,
        shareUrl = this._getClipUrl(curClip, {
          src: CLIP_SHARE_PARAM
        }),
        shareDesc = utils.i18n('clip.slideview.share_message', [position, slideshare_object.slideshow.title]);
      this.shareModal = new ClipboardModalShare({
        el: selectors.clipShareModal,
        modalTitle: shareDesc,
        shareEntityType: "clip",
        shareEntity: {
          id : curClip.id,
          url : shareUrl,
          description : shareDesc
        },
      });
      this.shareModal.open();
    },

    /**
     * Returns absolute url for the clip
     * @param {Object} clip - whose url is being fetched
     * @param {Object} queryParams - hash of query params to be appended to url
     * @returns {String}
     */
    _getClipUrl: function(clip, queryParams){
      var url = ss.slideshow.ss_url;
      queryParams = queryParams || {};
      if (clip) {
        url += "/" + clip.position;
      }
      return url + "?" + $.param(queryParams);
    },

    /**
     * Returns the url for the clipboard
     * @param {Object} clipboard - whose url is being fetched
     * @returns {String}
     */
    _getClipboardUrl: function(clipboard) {
      var clipboardsUrl = ss.user.clipboards_url;

      //rftp param is used for referrerType li tracking
      return  clipboardsUrl + "/" + clipboard.slug + "?rftp=success_toast";
    },

    /**
     * Get the slide thumbnail
     * @private
     * @param {Integer} position The position of the slide
     * @return {String} url of the slide image
     */
    _getSlideThumb: function(position) {
      var $slide = this.$slides.find(selectors.slide + '[slidenumber="' + position + '"]'),
          $thumb = $slide.find('img');

      if ($thumb.length) {
        return $thumb.attr('data-small');
      }
    },

    /**
     * Callback for after NoticePrompt hides itself
     * Detach event listeners for hiding the toast
     */
    _onHide: function() {
      clearTimeout(this.hideToastTimer);
      $(document).off('click' + eventNamespace);
      this.$el.off('click' + eventNamespace);
      this.$el.off('mouseenter' + eventNamespace);
      this.$el.off('mouseleave' + eventNamespace);

      $(document).trigger(events.successToastHide);
    },

    /**
     * Creates the toast using clip and clipboard data
     * Calls notice prompt show
     */
    show: function(e, data){
      if (isMobile) { return; }

      var clip = $.extend({}, data.clip, {
            thumbnail: this._getSlideThumb(data.clip.position)
          }),
          clipboard;

      if (e.type === events.clipMoved) {
        clipboard = data.toClipboard;
      } else {
        clipboard = data.clipboard;
      }
      clipboard = $.extend({}, clipboard, {
        url: this._getClipboardUrl(clipboard)
      });

      this.clip = clip;
      this.clipboard = clipboard;
      this.$toastContainer.empty().append(templates.successToast($.extend({
        clipboard: clipboard,
        clip: clip
      }, {
        i18n: i18n,
        message: utils.i18n('clip.slideview.success_toast.message', [clip.position, {
          title: clipboard.title,
          href: clipboard.url,
          class: "clipboard-title"
        }, clipboard.title])
      })));
      this.noticePrompt.show();

      this._attachHideToastEvents();
    },

    /**
     * Calls notice prompt hide
     */
    hide: function(){
      this.noticePrompt.hide();
    }

  };

  ss.utils.exports('clips.SuccessToast', SuccessToast);

})(window.slideshare_object);
